<template>
<div class="faq_page page">

	<topheader back="back">
        <template v-slot:info>
            <span>{{$t('caption.FAQ')}}</span>
        </template>
		<template v-slot:right>
			<div class="buttonpanel" v-if="auth">
				<router-link to="/chat?support=true">
					<i class="fa-solid fa-headset"></i>
				</router-link>
			</div>
		</template>
    </topheader>

	

	<maincontent>
		<template v-slot:content>
			<div class="wrapper mobp">
				<faq />
			</div>
		</template>
	</maincontent>

</div>
</template>

<style scoped lang="sass">

</style>

<script>

import faq from '@/components/modules/faq/index.vue'
import { mapState } from 'vuex';

export default {
	name: 'faq_page',
	components: {
        faq
	},

	computed: mapState({
        auth : state => state.auth,
        locale : function(state){
            return this.locales[state.locale] ? state.locale : 'en'
        }
    }),

	methods: {

	},

	mounted() {

	}
}
</script>
